<template>
  <div class="doby">
    <div class="header">
      <img class="img col-xs-1" src="../../assets/img/logo_blanco[27].png" />
    </div>

    <div class="row mb-3">
      <div class="col-2"></div>
      <div class="col-8">
        <div v-if="!tramiteEnviado" class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-6">
                <h4 class="card-title">Carga de documentación</h4>
              </div>
    
              <div class="form-group col-6 tablet-sm-6">
                <h5 class="card-title float-right ">Folio: {{ folio }}</h5>
              </div>
    
              <div class="col-12">
                <h6 class="card-title titulo5">
                  Para continuar con el tramite, por favor ingresa la documentación
                  solicitada:
                </h6>
                <p
                  >(*Al seleccionar tu archivo dar click en cargar para almacenar
                  tus documentos.)</p
                >
                <div class="table-responsive col-12-md">
                  <table class="table">
                    <thead>
                      <tr class="table-blue">
                        <th class="columna" scope="col">Documento</th>
                        <th class="columnaCargar" scope="col">Cargar Archivo</th>
                        <th class="columnaBtn"></th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(file, h) in listArchivos" :key="h">
                        <td>{{ file.Txt_requisito }}</td>
                        <td>
                          <input
                            type="file"
                            class="file-select"
                            :disabled="file.Id_Archivo !== '0'"
                            @change="onChangeFile($event, file)"
                            multiple
                          />
                        </td>
                        <td>
                          <button
                            :disabled="file.ACEPTADO === 'NO' || loading"
                            @click="cargar(file)"
                            type="button"
                            class="btn btn-success btn-sm mr-1 mb-1"
                          >
                            Cargar
                          </button>
    
                          <button
                            :disabled="file.Id_Archivo === '0'"
                            @click="eliminar(file)"
                            type="button"
                            class="btn btn-danger btn-sm mb-1"
                          >
                            Eliminar
                          </button>
                        </td>
                        <td>
                          <button @click=" mostrarPDF(file.Valor, file.tipo)" v-if="file.Archivo !== ''" class="btn btn-link ml-3" >
                            <img class="imgpdf col-xs-1" src="../../assets/img/pdf.png" />
                          </button>
                          <!-- <label id="lblacta" for="">{{ file.Archivo }}</label> -->
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <button @click="sendTramite" class="btn btn-primary--custom m-4 float-right">Enviar</button>
            <CModal size="lg" color="" :show.sync="modals.pdfModal" :close-on-backdrop="false">
              <template #footer-wrapper><span></span></template>
              <div class="card-body p-0">
                <iframe class="iframePdf" :src="pdf" frameborder="0"></iframe>
                <h5 class="text-center mt-1 mb-1">{{ txt }}</h5>
              </div>
              <!-- <CCardFooter align="right" class="pt-3 pl-0 pr-0 pb-0">
                <CButton @click="modals.pdfModal = false" color="outline-secondary"
                  >Cerrar
                </CButton>
              </CCardFooter> -->
        </CModal>
          </div>
        </div>

        <div v-if="tramiteEnviado" class="card" >
          <div class="card-body text-center">
            <div class="col-12 mt-4 mb-4">
              <h1 class="text-center text-succes">
                <svg  xmlns="http://www.w3.org/2000/svg" width="160" height="100" fill="currentColor" class="bi bi-check-circle" viewBox="0 0 16 16">
                  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                  <path d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z"/>
                </svg>
              </h1>
                <h4 class="card-title text-center mt-4">Documentos enviados exitosamente</h4>
            </div>
          </div>
        </div>
      </div>
      <div class="col-2"></div>
    </div>



    <loading v-if="load"></loading>
  </div>
</template>

<script>
import axios from "axios";
import Loading from '../../componentes/ImgLoading/loading.vue';
export default {
  components: {Loading},
  data() {
    return {
      listArchivos: [],
      listMulti: [],
      listAlmacenados: [],
      Acta: [],
      Acta2: [],
      DocActa: false,
      loading: false,
      load: true,
      token: this.$route.params.token,
      idCtrlSolicitud: "",
      folio: "",
      tipoArchivo: "",
      extenArchivo: "",
      nombreArchivo: "",
      Archivo: "",
      archivoBase64: "",
      pdf: "",
      txt: "",
      modals: { pdfModal: false },
      listArchiPDF: [],
      myWindow: "",
      tramiteEnviado: false,
      idProceso: "",
      idEstatusRechaza: "",
      idEstatusAcepta: "",
    };
  },
  methods: {
    modal() {
      this.$swal({
        icon: "success",
        title: "Documentos enviados exitosamente",
        showConfirmButton: false,
        timer: 2200,
      });
    },
    onChangeFile(event, file) {
      for (let e = 0; e < this.listArchivos.length; e++) {
        if (file.IDCatRequisito === this.listArchivos[e].IDCatRequisito) {
          this.listArchivos[e].ACEPTADO = "SI";
        }
      }

      if (event.target.files.length > 1) {
        this.$emit("update:modelValue", event.target.files[0]);

        this.listMulti = event.target.files;
      } else {
        this.nombreArchivo = event.target.files[0].name;
        this.tipoArchivo = event.target.files[0].type;
        this.extenArchivo = "." + event.target.files[0].name.split(".").pop();
        this.Archivo = event.target.files[0];
        this.listArchiPDF.push(this.Archivo)
      }
      for (let e = 0; e < this.listArchivos.length; e++) {
        if (file.IDCatRequisito === this.listArchivos[e].IDCatRequisito) {
          this.listArchivos[e].tipo = this.tipoArchivo;
        }
      }
      console.log(this.listArchivos);
    },

    async cargar(file) {
      this.load = true;
      // if (this.tipoArchivo !== "application/pdf") {
      //   // alerta de rror
      //   this.$swal({
      //     icon: "warning",
      //     title: "Archivo invalido",
      //     text: "Solo cargar archivos PDF",
      //     showConfirmButton: false,
      //     timer: 2200,
      //   });
      //   return;
      // }
      if (this.listMulti.length !== 0) {
        for (let e = 0; e < this.listMulti.length; e++) {
          this.nombreArchivo = this.listMulti[e].name;
          this.tipoArchivo = this.listMulti[e].type;
          this.extenArchivo = "." + this.listMulti[e].name.split(".").pop();
          this.Archivo = this.listMulti[e];
          this.archivoBase64 = await this.convertBase64(this.Archivo);
          await this.realizapeti(file);
        }
        this.listMulti = [];
      } else {
        this.archivoBase64 = await this.convertBase64(this.Archivo);
        await this.realizapeti(file);
      }
    },
    eliminar(file) {
      // pregunta si esta seguro eliminar
      this.$swal({
        title: "Estas seguro?",
        text: "No podrás revertir esta acción!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Borrar",
      }).then((result) => {
        if (result.isConfirmed) {
          let arrTemp = this.listAlmacenados;

          for (let i = 0; i < arrTemp.length; i++) {
            if (file.ID_Requisito === arrTemp[i].ID_Requisito) {
              this.listAlmacenados[i] = null;
            }
          }

          this.listAlmacenados = this.listAlmacenados.filter(Boolean);

          for (let e = 0; e < this.listArchivos.length; e++) {
            if (file.IDCatRequisito === this.listArchivos[e].IDCatRequisito) {
              this.listArchivos[e].ACEPTADO = "NO";
              this.listArchivos[e].Id_Archivo = "0";
              this.listArchivos[e].Archivo = "";
            }
          }

          this.nombreArchivo = "";
          this.tipoArchivo = "";
          this.extenArchivo = "";
          this.Archivo = null;
          this.listMulti = [];
          this.listAlmacenados = [];

          this.$swal(
            "Eliminado!",
            "" + file.Archivo + "Archivo eliminado correctamente",
            "success"
          );
          // }else {
          // si nono hace nada
        }
      });
    },

    convertBase64(blob) {
      return new Promise((resolve, reject) => {
        var reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = () => {
          resolve(reader.result.split(",")[1]);
        };
      });
    },

    async realizapeti(file) {
      const payload = {
        metodo: "GUARDARARCHIVOSCONTRATACION",
        data: {
          base64: this.archivoBase64,
          nombre: this.nombreArchivo,
          contentType: this.tipoArchivo,
          extension: this.extenArchivo,
        },
      };
      try {
        const response = await this.$store.dispatch("metodoPost", payload);
        if (response) {
          const res = this.$store.getters.getRespuestaREST;

          const itemFile = {
            nombre: this.nombreArchivo,
            contentType: this.tipoArchivo,
            extension: this.extenArchivo,
            idArchivo: res,
            ID_Requisito: file.ID_Requisito,
            IDCatRequisito: file.IDCatRequisito,
          };

          this.listAlmacenados.push(itemFile);
          
          for (let e = 0; e < this.listArchivos.length; e++) {
            if (file.IDCatRequisito === this.listArchivos[e].IDCatRequisito) {
              this.listArchivos[e].ACEPTADO = "NO";
              this.listArchivos[e].Id_Archivo = res;
              this.listArchivos[e].Archivo = this.nombreArchivo;
              this.listArchivos[e].Valor = this.archivoBase64;
            }
          }
          
          // alert de cargado con exito
          this.loading = false;
          this.$swal({
            icon: "success",
            title: "Archivo cargado",
            text:
              "El archivo " + this.nombreArchivo + " se cargo exitosamente.",
            showConfirmButton: true,
          });
        } else {
          this.$swal({
            icon: "error",
            title: "Error",
            text:
              "El archivo " +
              this.nombreArchivo +
              " no se pudo cargar, intentalo más tarde.",
            showConfirmButton: true,
          });
        }
      } catch (error) {}
    },
    async ValidarToken() {
      this.load = false
      var config = {
        metodo: "VALIDATOKENRUTA",
        data: `sToken=${this.token}`,
      };

      this.$store.dispatch("metodoPost", config).then(() => {
        const res = this.$store.getters.getRespuestaREST;

        if (res.flag) {
          this.idCtrlSolicitud = res.data.idCtrlSolicitud;
          this.folio = res.data.Folio;
          this.idEstatusAcepta = res.data.idEstatusAcepta
          this.idEstatusRechaza = res.data.idEstatusRechaza
          this.idProceso = res.data.idProceso
        } else {
          window.location.href = `${location.origin}/#/pages/app/errorToken`;
        }
        console.log(res);
      });
    },
    async Requisitos() {
      this.load = true;
      const payload = {
        metodo: "OBTENERREQUISITOSCONTRATACION",
        data: {
          idCtrlSolicitud: this.idCtrlSolicitud,
          Folio: this.folio,
        },
      };
      try {
        const response = await this.$store.dispatch("metodoPost", payload);
        if (response) {
          const res = this.$store.getters.getRespuestaREST;
          this.listArchivos = res;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async sendTramite() {
      this.load = true;
      const payload = {
        metodo: "SETTRAMITEVILLREQ",
        data: {
          idCtrlSolicitud: this.idCtrlSolicitud,
          Folio: this.folio,
          idCatAccion: "2",
          idEstatusAcepta: this.idEstatusAcepta,
          idEstatusRechaza: this.idEstatusRechaza,
          idProceso: this.idProceso,
          sComentarios: "SE ENVIAN DOCUMENTOS.",
          lstArchivos: this.listAlmacenados,
        },
      };
      console.log(payload);
      try {
        const response = await this.$store.dispatch("metodoPost", payload);
        if (response) {
          const res = this.$store.getters.getRespuestaREST;
          this.$swal({
            icon: "success",
            title: "Correcto",
            text:
              "Hemos recibido tu documentación, en breve serás contactado por La Latino Seguros, Gracias.",
            showConfirmButton: true,
          });
          this.tramiteEnviado = true;
          this.listAlmacenados = [];
          this.listMulti = [];
          this.nombreArchivo = "";
          this.tipoArchivo = "";
          this.extenArchivo = "";
          this.Archivo = null;
          this.listArchivo = [];
        } else {
          this.$swal({
            icon: "error",
            title: "Error",
            text: "Ocurrio un error intenta mas tarde.",
            showConfirmButton: true,
          }).then((result) => {
          })
         }
      } 
      catch (error) {
        console.log(error);
      }
    },

    async mostrarPDF(base64, tipo) {
      this.modals.pdfModal = true
      var bin = atob(base64);
      switch (tipo) {
        case 'image/jpeg':
          this.pdf = 'data:image/jpeg;base64,' + base64;
          this.txt = ""
          break;
        case 'image/png':
          this.pdf = 'data:image/png;base64,' + base64;
          this.txt = ""
          break;
        case 'application/pdf':
          this.pdf = 'data:application/pdf;base64,' + base64;
          this.txt = ""
          break;
      
        default:
          this.pdf = "";
          this.txt = "No se puede visualizar el documento cargado."
          break;
      }
    }
  },
  mounted() {
    const promise = new Promise((resolve, _) => {
          resolve(this.ValidarToken());
        });
        promise.then(_ => {
          setTimeout(() => {
            this.Requisitos();
          }, 1500)
        }
      );
  },
};
</script>
<style>
.iframePdf {
  width: 100%;
  height: 400px;
}
.header {
  background-color: #003873;
  height: 150px;
}
.img {
  height: 120px;
  margin-left: 25px;
  margin-top: 15px;
}
.card {
  /* width: 50rem; */
  height: 98%;
  margin: 30px;
  border-radius: 25px;
}
.titulo5 {
  color: gray;
}
.parrafo {
  font-size: 12px;
  color: gray;
}
.imgpdf {
  height: 35px;
}
.table-blue {
  background-color: #003873;
  color: white;
}
/* table{
  table-layout: fixed;
} */
.columna {
  width: 400px;
  overflow: auto;
}
/* .columnaCargar {
  width: 400px;
  overflow: auto;
}
.columnaBtn {
  width: 190px;
  overflow: auto;
} */

.file-select {
    position: relative;
    display: inline-block;
    width: 160px;
    height: 35px;
    margin-right: 20px;
  }
  
  .file-select::before {
    background-color: #e2e1e1;
    color: rgb(153, 152, 152);
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 3px;
    font-size: small;
    content: "Seleccionar archivo";
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
  }
</style>
